<template>
  <div class="filter-container" :class="{ 'filter-expanded': filterExpanded }">
    <!-- Filter Button -->
    <q-btn 
      @click="toggleFilter()" 
      class="filter-btn" 
      :class="{ 'filter-active': filterExpanded }"
      :title="filterExpanded ? closeButtonTitle : filterButtonTitle"
      :icon="filterExpanded ? 'close' : 'filter_alt'"
      flat 
      round
      text-color="grey-7"
    />

    <!-- Filter Options Container -->
    <Transition name="filter-slide">
      <div v-if="filterExpanded" class="filter-options-container">
        <div class="filter-options-wrapper">
          <!-- Platform Filter -->
          <div class="filter-section">
            <label class="filter-label">Platform</label>
            <q-select
              v-model="selectedPlatform"
              :options="platformOptions"
              emit-value
              map-options
              outlined
              dense
              @update:model-value="handlePlatformChange"
            />
          </div>
          
          <!-- Additional filters can be added here -->
          <!-- <div class="filter-section">
            <label class="filter-label">Date Range</label>
            <q-input 
              v-model="dateFilter" 
              type="date" 
              outlined 
              dense
              @update:model-value="handleDateChange"
            />
          </div> -->
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
  filterButtonTitle: {
    type: String,
    default: 'Filter'
  },
  closeButtonTitle: {
    type: String,
    default: 'Close Filter'
  },
  platformOptions: {
    type: Array,
    default: () => []
  },
  modelValue: {
    type: String,
    default: 'all'
  }
})

const emit = defineEmits([
  'filter-changed',
  'filter-opened',
  'filter-closed',
  'update:modelValue',
  'platform-changed',
  'date-changed'
])

const filterExpanded = ref(false)
const justOpened = ref(false)
const selectedPlatform = ref(props.modelValue)
const dateFilter = ref('')

const toggleFilter = () => {
  if (filterExpanded.value) {
    closeFilter()
  } else {
    filterExpanded.value = true
    justOpened.value = true
    emit('filter-opened')
    setTimeout(() => {
      justOpened.value = false
    }, 100)
  }
}

const closeFilter = () => {
  filterExpanded.value = false
  justOpened.value = false
  emit('filter-closed')
}

const handleOutsideClick = (event) => {
  if (justOpened.value) return
  if (filterExpanded.value && !event.target.closest('.filter-container')) {
    closeFilter()
  }
}

const handleGlobalKeydown = (event) => {
  if (!filterExpanded.value) return
  
  if (event.key === 'Escape') {
    closeFilter()
  }
}

const handlePlatformChange = (value) => {
  selectedPlatform.value = value
  emit('update:modelValue', value)
  emit('platform-changed', value)
  emit('filter-changed', { platform: value, date: dateFilter.value })
}

const handleDateChange = (value) => {
  dateFilter.value = value
  emit('date-changed', value)
  emit('filter-changed', { platform: selectedPlatform.value, date: value })
}

onMounted(() => {
  document.addEventListener('click', handleOutsideClick)
  document.addEventListener('keydown', handleGlobalKeydown)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleOutsideClick)
  document.removeEventListener('keydown', handleGlobalKeydown)
})
</script>

<style scoped>
.filter-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row-reverse;
}

/* Filter Button */
.filter-btn {
  width: 40px;
  height: 40px;
  /* border: 1px solid #d1d5db; */
  border-radius: 6px;
  /* background: white; */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  /* color: #6b7280; */
  transition: all 0.2s ease;
  /* box-shadow: 0 1px 3px rgba(0,0,0,0.1); */
  flex-shrink: 0;
}

.filter-btn:hover,
.filter-btn.filter-active {
  /* background: #f9fafb; */
  /* border-color: #3b82f6; */
  /* color: #3b82f6; */
}

/* Filter Options Container */
.filter-options-container {
  display: flex;
  align-items: center;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
  margin-top: 8px;
}

.filter-options-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 320px;
  padding: 16px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.filter-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

/* Transitions */
.filter-slide-enter-active,
.filter-slide-leave-active {
  transition: all 0.3s ease;
}

.filter-slide-enter-from {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
}

.filter-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
}

/* Responsive */
@media (max-width: 768px) {
  .filter-options-wrapper {
    width: 280px;
  }
}

@media (max-width: 600px) {
  .filter-options-wrapper {
    width: 250px;
  }
}
</style>